import React, { SVGAttributes } from 'react'

const SvgClose = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" {...props}>
    <path
      d="M9.786.214a.69.69 0 00-1 0L5 4 1.214.214a.69.69 0 00-1 0 .69.69 0 000 1L4 5 .214 8.786a.69.69 0 000 1 .648.648 0 00.5.214.648.648 0 00.5-.214L5 6l3.786 3.786a.772.772 0 00.5.214.772.772 0 00.5-.214.69.69 0 000-1L6 5l3.786-3.786a.69.69 0 000-1"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export default SvgClose
